import { Button } from "antd";

export function Message ( message, open, close ) {
    return (
        <div 
            className="center"
            style={{ 
                position:'absolute', 
                width: '100vw', 
                height:'100vh',
                backgroundColor:'trasparent', 
                zIndex: 100, 
                display: !open ? 'none' : '',
                }}>

            <div 
                className="center bg-color-secondary"
                style={
                    {
                        flexDirection:'column',
                        width:  '300px',
                        height: '100px',
                    }}>
                        <div>{message}</div>
                    <Button onClick={() => close()} > Ok </Button>
            </div>

        </div>
    )
}